const base = import.meta.env.VITE_API_URL || "/rest/api"
export const API_BASE = `${base}/v1`
